import { Flex, Link, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { CaseLink, noPositionText } from "../../styles_vanilla.css";
import { PositionPropsType } from "../../types";

type Props = {
  positionProps?: PositionPropsType;
};

const PositionDetail = ({ positionProps }: Props) => {
  if (positionProps?.positionId != null) {
    return (
      <Link
        to={`/compliance/positions?arenaIds=${positionProps?.arenaId}&entityId=${positionProps?.entityId}`}
        shouldOpenInNewTab
        className={CaseLink}
        icon="external-link"
        iconPosition="right"
      >
        {`Position in ${positionProps?.entityName || "--"}`}
      </Link>
    );
  }

  return (
    <Flex gap={4} flexDirection="row" alignItems="center">
      <Icon type="unlink" color={Colors.Danger400} />
      <Text variant="secondary-sm" className={noPositionText}>
        No linked position
      </Text>
    </Flex>
  );
};

export default PositionDetail;
